export const hasUserPhoto = (file) => {
  if (typeof File !== 'undefined' && file instanceof File) return true
  if (typeof Blob !== 'undefined' && file instanceof Blob) return true
  const name = String(file || '').trim()
  if (!name) return false
  if (/^(null|undefined|none|default)$/i.test(name)) return false
  return true
}

const PALETTES = [
  { bg: '#2a3140', skin: '#ffd7b3', shirt: '#ff5d73', hair: '#5c3d2e' },
  { bg: '#243040', skin: '#ffd0a8', shirt: '#3b82f6', hair: '#2f2a44' },
  { bg: '#262d38', skin: '#f8c8a0', shirt: '#22c55e', hair: '#6b3f2a' },
  { bg: '#2b313c', skin: '#ffd9b8', shirt: '#a855f7', hair: '#3f2a4a' },
  { bg: '#283040', skin: '#efc09a', shirt: '#f97316', hair: '#4a2c1a' },
  { bg: '#2a323e', skin: '#ffd6b0', shirt: '#6366f1', hair: '#1f2937' }
]

const nameHash = (value) => {
  const text = String(value || 'U')
  let hash = 0
  for (let i = 0; i < text.length; i += 1) hash = (hash * 31 + text.charCodeAt(i)) >>> 0
  return hash || 1
}

const hairBehind = (style, hair) => {
  if (style === 1) {
    return `<path d="M14 24c1-13 8-20 18-20s17 7 18 20v26c-5-9-11-12-18-12s-13 3-18 12z" fill="${hair}"/>`
  }
  if (style === 2) {
    return `<circle cx="16" cy="16" r="8" fill="${hair}"/><circle cx="48" cy="16" r="8" fill="${hair}"/>`
  }
  return ''
}

const hairFront = (style, hair) => {
  if (style === 1) {
    return `<path d="M16 22c4-8 10-10 16-10s12 2 16 10" fill="${hair}"/>`
  }
  if (style === 2) {
    return `<circle cx="20" cy="14" r="7" fill="${hair}"/><circle cx="32" cy="11" r="8" fill="${hair}"/><circle cx="44" cy="14" r="7" fill="${hair}"/>`
  }
  return `<ellipse cx="32" cy="13" rx="13" ry="7" fill="${hair}"/>`
}

export const letterAvatar = (label = 'U') => {
  const name = String(label).trim() || 'U'
  const letter = (name.charAt(0) || 'U').toUpperCase()
  const hash = nameHash(name)
  const palette = PALETTES[hash % PALETTES.length]
  const style = hash % 3
  const ink = '#1f2430'

  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
    <rect width="64" height="64" rx="32" fill="${palette.bg}"/>
    ${hairBehind(style, palette.hair)}
    <ellipse cx="32" cy="56" rx="20" ry="16" fill="${palette.shirt}"/>
    <text x="32" y="55" text-anchor="middle" dominant-baseline="middle" font-family="system-ui,sans-serif" font-size="13" font-weight="800" fill="#fff">${letter}</text>
    <circle cx="32" cy="26" r="16" fill="${palette.skin}"/>
    <circle cx="21" cy="24" r="3.2" fill="${palette.skin}"/>
    <circle cx="43" cy="24" r="3.2" fill="${palette.skin}"/>
    ${hairFront(style, palette.hair)}
    <circle cx="26.2" cy="26.5" r="2.4" fill="${ink}"/>
    <circle cx="37.8" cy="26.5" r="2.4" fill="${ink}"/>
    <circle cx="26.9" cy="25.8" r=".8" fill="#fff"/>
    <circle cx="38.5" cy="25.8" r=".8" fill="#fff"/>
    <ellipse cx="22" cy="31" rx="2.6" ry="1.4" fill="#ff8fab" opacity=".75"/>
    <ellipse cx="42" cy="31" rx="2.6" ry="1.4" fill="#ff8fab" opacity=".75"/>
    <path d="M25.5 33.5c2.4 3.4 10.6 3.4 13 0" fill="none" stroke="${ink}" stroke-width="1.8" stroke-linecap="round"/>
  </svg>`
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`
}

export const avatarUrl = (file, label) => {
  if (!hasUserPhoto(file)) return letterAvatar(label)
  if (typeof File !== 'undefined' && file instanceof File) return URL.createObjectURL(file)
  if (typeof Blob !== 'undefined' && file instanceof Blob) return URL.createObjectURL(file)
  const name = String(file)
  if (name.startsWith('/') || name.startsWith('http') || name.startsWith('data:')) return name
  return `/api/uploads/${name}`
}
